<template>
  <section class="question-block">
    <div class="question-block-question">
      <p>
        Do you work as an assistant practitioner, radiographic assistant or
        support worker to a radiographic team?
      </p>
    </div>
    <div class="question-control question-control--boolean">
      <div class="radio-input radio-input--btn">
        <input type="radio" id="apraYes" name="apra" :value="true" />
        <label @click="goToRoute('radiographic-assistant')" for="apraYes">
          Yes
        </label>
      </div>
      <div class="radio-input radio-input--btn">
        <input type="radio" id="apraNo" name="apra" :value="false" />
        <label @click="goToRoute('study')" for="apraNo">
          No
        </label>
      </div>
    </div>
  </section>
</template>

<script>
import { baseWizardUrl } from "@/helpers/wizard-helper.js";
export default {
  setup(_, ctx) {
    function goToRoute(route) {
      ctx.root.$router.push({ path: `${baseWizardUrl}/${route}` });
    }
    return {
      goToRoute,
    };
  },
};
</script>

<style lang="scss" scoped></style>
